<div id="cm__main-content" style="display: block">
  <div #idpAdmin class="cm__container user-admin-content is-fullwidth">
    <div class="cm__container__col">
      <div class="cm__container is-7030">
        <div class="cm__container__col">
          <section class="cm__idp-admin">
            <div>
              <h1 class="cm__section-heading">User Administration</h1>
              <h2 class="cm__sub-heading">Search for User</h2>
            </div>

            <div class="cm__idp-admin__form cm__form js-form js-internal-tool-admin-help-desk">
              <div class="cm__form__row cm__form__row--100" role="alert">
                <div class="cm__admin__server-error">{{ errorMessage }}</div>
              </div>
              <div
                *ngIf="alertResponse !== ''"
                role="alert"
                class="cm__idp-admin__alert cm__admin__response-msg js-alert-response fade-text"
              >
                {{ alertResponse }}
              </div>

              <!-- USER ID / SEARCH BUTTON -->
              <div class="cm__form__row form-group form-floating">
                <input
                  type="text"
                  id="IDP_USER_ID"
                  class="form-control userid"
                  name="userid"
                  data-type="string"
                  [(ngModel)]="userId"
                  placeholder="User ID:"
                />
                <label for="IDP_USER_ID">User ID:</label>
                <button
                  type="button"
                  class="cm__button cm__button--arrow cm__button--secondary cm__button--small js-fm-search"
                  aria-disabled="false"
                  (click)="searchUser(false)"
                >
                  Search
                </button>
              </div>

              <!-- CURRENT SELECTED USER NAME AND ID -->
              <!-- USER PROGRESS STATUS -->
              <div class="cm__form__row">
                <div class="cm__idp-admin__defs">
                  <span class="cm__idp-admin__key">Selected User Identity Status</span>
                  <table class="cm__idp-admin__value user-details-table" role="presentation">
                    <tbody>
                      <tr>
                        <td class="cm__idp-admin-bold">Name (User ID):</td>
                        <td class="js-fm-username">
                          <span
                            *ngIf="userDetails.firstName || userDetails.lastName || userDetails.userId; else notFound"
                            class="cm__idp-admin__value js-fm-username"
                            >{{ userDetails.firstName }} {{ userDetails.lastName }} ({{
                              userDetails.userId | uppercase
                            }})</span
                          >
                          <ng-template #notFound>
                            @if (userDetails.response && userDetails.response === 'User not Found') {
                              <span class="cm__idp-admin__value js-fm-username">Not found ()</span>
                            }
                          </ng-template>
                        </td>
                      </tr>
                      <tr>
                        <td class="cm__idp-admin-bold">Active Directory Email:</td>
                        <td>
                          <span
                            *ngIf="userDetails.emailAddress; else notFoundEmail"
                            class="cm__idp-admin__value js-fm-email"
                            >{{ userDetails.emailAddress }}</span
                          >
                        </td>
                        <ng-template #notFoundEmail>
                          <span
                            class="cm__idp-admin__value js-fm-email"
                            *ngIf="userDetails.response && userDetails.response === 'User not Found'"
                          ></span>
                        </ng-template>
                      </tr>
                      <tr>
                        <td class="cm__idp-admin-bold">MFA Status:</td>
                        <td class="js-mfa-status">
                          @if (userDetails.mfaDetails) {
                            {{
                              userDetails.mfaDetails && userDetails.mfaDetails.enrolledDate === null
                                ? 'Has not enrolled in MFA'
                                : 'Last updated on ' + userDetails.mfaDetails.enrolledDate
                            }}
                          }
                        </td>
                      </tr>
                      <tr>
                        <td class="cm__idp-admin-bold">IDP Status:</td>
                        <td class="js-idp-status">
                          @if (userDetails.response) {
                            {{
                              userDetails.idpEnrolledDate === null
                                ? 'Has not completed IDP'
                                : 'Last updated on ' + userDetails.idpEnrolledDate
                            }}
                          }
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="text--left">
                  <button
                    type="button"
                    class="link cm__idp-admin__small-text js-link-text-idp-status"
                    (click)="toggleDiv(0)"
                  >
                    <span>Click here for more information on User Identity Status</span>
                  </button>
                </div>
                <div hidden="true" class="toggle-div js-text -idp-status cm__idp-admin__small-text">
                  This section shows a user's first name, last name and userid. The email address could be different
                  than an MFA email address listed later on the screen. MFA Status will list the date when the user last
                  completed MFA or will show "not enrolled". IDP Status will list the date when the user completed IDP
                  or will show "not completed". If IDP was completed within the past hour, user is allowed into the site
                  without challenge.
                </div>
                <hr />
              </div>
              <!-- BYPASS CODE -->
              <div class="cm__form__row" style="margin-bottom: 12px">
                <div>
                  <span class="cm__idp-admin__key">Bypass Code</span>
                  <span class="cm__idp-admin__value js-bypass-code-text" *ngIf="userDetails.firstName"
                    >{{ userDetails.bypassCode ? userDetails.bypassCode : '' }}
                  </span>
                  <span class="cm__idp-admin__small-text js-bypass-code-timestamp" *ngIf="userDetails.firstName">{{
                    userDetails.bypassCodeDate ? 'Last updated on ' + dateProcess(userDetails.bypassCodeDate) : ''
                  }}</span>
                </div>
                <div class="cm__idp-admin__btn-group">
                  <button
                    type="button"
                    class="cm__button cm__button--arrow cm__button--secondary cm__button--small js-btn-gen-bypass-code"
                    (click)="onClickGenerateBypassCode()"
                  >
                    <span>Generate Bypass Code</span>
                  </button>

                  <button
                    type="button"
                    class="cm__button cm__button--arrow cm__button--secondary cm__button--small js-btn-gen-bypass-code"
                    (click)="onClickClearBypassCode()"
                  >
                    <span class="bypasscode">Clear Bypass Code</span>
                  </button>
                  <div
                    class="cm__admin__response-msg js-bypass-code-response fade-text-delay"
                    role="alert"
                    *ngIf="byPassCodeResponse !== ''"
                  >
                    {{ byPassCodeResponse }}
                  </div>
                  <div class="cm__admin__server-error" *ngIf="byPasserrorMessage !== ''">{{ byPasserrorMessage }}</div>
                </div>
                <div class="text--left">
                  <button
                    type="button"
                    class="link cm__idp-admin__small-text js-link-text-bypass-codes"
                    (click)="toggleDiv(1)"
                  >
                    <span>Click here for more information on generating Bypass Codes</span>
                  </button>
                </div>
                <div hidden="true" class="toggle-div js-text -bypass-codes cm__idp-admin__small-text">
                  Bypass codes enable the user to permanently bypass IDP and to temporarily bypass MFA page flow for 24
                  hours to allow the Advisor to get to the Advisor home page without delay. When a bypass code is
                  generated for the user, the next time they login they will be prompted to enter their code. Once the
                  user enters the correct code and clicks Next, they will be redirected to the Advisor home page. After
                  being used, the bypass code will be removed from the Admin page and it will not be available to be
                  used again. The MFA bypass will allow Advisors to login for the next 24 hours without needing to use
                  muli-factor authentication, even across different browser sessions and devices. The date and time they
                  used a bypass code is displayed above.
                </div>
                <hr />
              </div>

              <!-- IDP RESET -->
              <div class="cm__form__row">
                <div class="cm__idp-admin__defs" style="margin-bottom: 0">
                  <span class="cm__idp-admin__key idp-heading">Identity Proofing (IDP) Completion</span>
                  <span class="cm__idp-admin__value js-idp-enrollment-date">
                    @if (userDetails.response) {
                      {{
                        userDetails.idpEnrolledDate === null
                          ? 'Has not completed IDP'
                          : 'Last updated on ' + userDetails.idpEnrolledDate
                      }}
                    }
                  </span>
                  <span class="cm__idp-admin__value js-idp-enrollment-method"></span>
                </div>

                <button
                  (click)="userDetails.idpMethod && resetIDP()"
                  style="margin-bottom: 16px"
                  type="button"
                  class="cm__button cm__button--arrow cm__button--secondary cm__button--small js-btn-idp-reset"
                >
                  <span>Reset IDP Completion</span>
                </button>
                <div class="cm__admin__response-msg js-idp-reset-response">{{ resetIDPResponse }}</div>
                <div class="cm__admin__server-error" *ngIf="resetIDPerrorMessage !== ''">
                  {{ resetIDPerrorMessage }}
                </div>
                <div class="text--left">
                  <button type="button" class="link cm__idp-admin__small-text" (click)="toggleDiv(2)">
                    <span>Click here for more information on resetting IDP</span>
                  </button>
                </div>
                <div hidden="true" class="toggle-div js-text -idp cm__idp-admin__small-text">
                  IDP is an identity proofing procedure that verifies the user is who they say they are. The user only
                  needs to do IDP once and then never again unless the IDP enrollment is reset above. The first step of
                  IDP is to ask the user information about them such as their personal address, personal phone number,
                  etc. Once the information is submitted they will either be sent a one-time passcode on their phone or
                  they will be asked a set of questions. If they either submit the correct one-time passcode or answer
                  the majority of the questions correctly then they will pass IDP and will never need to do it again. If
                  they fail to pass IDP they will be given another chance, however after 6 attempts in a 30 day period
                  the system will lock them out. Even resetting the IDP enrollment will not remove the lock. The only
                  way to get access is to give the user a bypass code (see above).
                </div>
                <hr />
              </div>

              <!-- MFA FACTORS RESET -->
              <div class="cm__form__row">
                <div class="cm__idp-admin__defs">
                  <span class="cm__idp-admin__key mfa-heading">Multi-Factor Authentication (MFA) Enrollment</span>
                  <span class="cm__idp-admin__value js-mfa-enrollment-date cm__idp-admin__small-text">
                    @if (userDetails.mfaDetails) {
                      {{
                        userDetails.mfaDetails && userDetails.mfaDetails.enrolledDate === null
                          ? 'Has not enrolled in MFA'
                          : 'Last updated on ' + userDetails.mfaDetails.enrolledDate
                      }}
                    }
                  </span>
                </div>
                <div
                  *ngIf="
                    userDetails.mfaDetails &&
                    userDetails.mfaDetails.factors &&
                    userDetails.mfaDetails.factors.length === 0
                  "
                  class="modelsDiv"
                >
                  <table role="presentation">
                    <tr>
                      <td>No MFA factors exist for this user</td>
                    </tr>
                  </table>
                </div>

                <!-- Start MFA factors -->
                <div
                  class="table-mfa"
                  *ngIf="
                    userDetails.mfaDetails &&
                    userDetails.mfaDetails.factors &&
                    userDetails.mfaDetails.factors.length > 0
                  "
                >
                  <table class="cm__admin-factors__table" role="presentation">
                    <tr class="cm__admin-factors__tablerow" *ngFor="let factor of userDetails.mfaDetails.factors">
                      <td class="cm__admin-factors__tablecell scrollable">
                        <div class="form-group custom-search form-floating">
                          <input
                            type="text"
                            class="form-control custom-search-input"
                            placeholder="Enter phonenumber"
                            aria-describedby="phone-error"
                            value="{{ factor.factorValue }}"
                            disabled="true"
                          />
                          <label for="phone"
                            >{{
                              factor.factorType === 0
                                ? 'Text Message'
                                : factor.factorType === 1
                                  ? 'Call'
                                  : factor.factorType === 2
                                    ? 'Email'
                                    : ''
                            }}
                          </label>
                        </div>
                      </td>
                      <td class="btn-fixed">
                        <button
                          type="button"
                          (click)="factor.factorType !== undefined && removeMfaFactor(factor.factorType)"
                          class="cm__button cm__button--arrow cm__button--secondary cm__button--small cm__button_clear"
                        >
                          <span>Clear</span>
                        </button>
                      </td>
                    </tr>
                  </table>
                </div>
                <!-- End MFA factors -->
                <div
                  class="cm__admin__response-msg js-mfa-clear-response fade-text-delay"
                  *ngIf="removeMfaResponse !== ''"
                  role="alert"
                >
                  <span> {{ removeMfaResponse }} </span>
                </div>
                <div class="cm__admin__server-error" *ngIf="mfaerrorMessage !== ''">{{ mfaerrorMessage }}</div>
                <div class="text--left">
                  <button type="button" class="link cm__idp-admin__small-text" (click)="toggleDiv(3)">
                    <span>Click here for more information on clearing MFA factors</span>
                  </button>
                </div>
                <div hidden="true" class="toggle-div js-text -mfa cm__idp-admin__small-text">
                  Multi-factor Authentication (MFA) is an additional authentication process that occurs when the user
                  logs into the system. The system sends the user a code and the user must enter the correct code to
                  gain access to the system. Codes can be sent via email, sms text, or voice phone call. The user can
                  setup one of these methods (referred to as factors) when they enroll in MFA. The first time an
                  external users (a non-employee user) logs in to
                  {{ siteUrl.charAt(0).toUpperCase() + siteUrl.slice(1) }} they will be led through the Identity
                  Proofing (IDP) page flow. If they successfully setup IDP with a phone, via code, their first MFA
                  factor will be setup for them. If they passed IDP with the questions/answers method then they will
                  need to enroll in MFA manually. They will be directed to a screen to setup one or more factors
                  (email/sms/voice). Once they select a method and enter their phone number or email address, they will
                  be sent a code. Successful entry of that code will complete the MFA enrollment process for that
                  factor, and the user may then access the Advisor home page. This tool allows the administrator to
                  remove individual MFA factors from the user. Once all MFA factors are removed, the user will be forced
                  to create a new factor to access {{ siteUrl.charAt(0).toUpperCase() + siteUrl.slice(1) }}.
                </div>
                <hr />
              </div>
            </div>
          </section>
        </div>

        <div class="cm__container__col"></div>
      </div>
    </div>
  </div>
</div>
